import {createTheme, colors} from "@material-ui/core";

export const appTheme = createTheme({
    palette: {
        //type: 'dark',
    },
    typography: {
        fontFamily: [
            'Ubuntu',
            'sans-serif',
        ].join(','),
    },
});

export const appStyles = {
    root: {
        flexGrow: 1,
        marginLeft: appTheme.spacing(2),
        marginRight: appTheme.spacing(2),
    },
    alignRight: {
        float: 'right',
    },
    appBar: {
        position: 'fixed',
        menuButton: {
            marginRight: appTheme.spacing(2),
        },
        title: {
            flexGrow: 1,
        },
    },
    eventStatusCancelled: {
        color: appTheme.palette.error.main,
    },
    eventStatusCompleted: {
        color: appTheme.palette.success.main,
    },
    layout: {
        width: 'auto',
        marginLeft: appTheme.spacing(2),
        marginRight: appTheme.spacing(2),
        [appTheme.breakpoints.up(600 + appTheme.spacing(6) * 2)]: {
            marginLeft: appTheme.spacing(6),
            marginRight: appTheme.spacing(6),
        },
        [appTheme.breakpoints.up(800 + appTheme.spacing(6) * 2)]: {
            maxWidth: 800,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    calendarLayout: {
        width: 'auto',
        marginLeft: appTheme.spacing(2),
        marginRight: appTheme.spacing(2),
    },
    pageTitle: {
        color: 'default',
        padding: appTheme.spacing(2),
    },
    calendarPaper: {
        marginTop: appTheme.spacing(1),
        marginBottom: appTheme.spacing(3),
        padding: appTheme.spacing(1),
    },
    paper: {
        marginTop: appTheme.spacing(1),
        marginBottom: appTheme.spacing(3),
        padding: appTheme.spacing(3),
        [appTheme.breakpoints.up(600 + appTheme.spacing(3) * 2)]: {
            marginTop: appTheme.spacing(2),
            marginBottom: appTheme.spacing(6),
            padding: appTheme.spacing(4),
        },
    },
    grid: {
      marginTop: appTheme.spacing(2),
      marginBottom: appTheme.spacing(2),
    },
    dialogTitle: {
        margin: 0,
        padding: appTheme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: appTheme.spacing(1),
        top: appTheme.spacing(1),
        color: appTheme.palette.grey[500],
    },
    flightPaper: {
        height: "100%"
    },
    auditContainer: {
        paddingLeft: appTheme.spacing(3),
        paddingRight: appTheme.spacing(3),
        paddingTop: appTheme.spacing(3),
        paddingBottom: appTheme.spacing(3),
    },
    flightContainer: {
        paddingLeft: appTheme.spacing(3),
        paddingRight: appTheme.spacing(3),
        paddingBottom: appTheme.spacing(3),
    },
    userContainer: {
        paddingTop: appTheme.spacing(2),
        paddingLeft: appTheme.spacing(3),
    },
    fabEdit: {
        backgroundColor: appTheme.palette.warning.light,
        '&:hover': {
            backgroundColor: appTheme.palette.warning.main,
        }
    },
    fabAdd: {
        backgroundColor: appTheme.palette.success.light,
        '&:hover': {
            backgroundColor: appTheme.palette.success.main,
        }
    },
    fabDelete: {
        backgroundColor: appTheme.palette.error.light,
        '&:hover': {
            backgroundColor: appTheme.palette.error.main,
        }
    },
    fab: {
        float: 'right',
        right: appTheme.spacing(-1),
        top: appTheme.spacing(-1),
        marginBottom: appTheme.spacing(-2),
        marginLeft: appTheme.spacing(1),
    },
    hoverCell: {
        paddingRight: appTheme.spacing(2),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: appTheme.spacing(-2),
    },
    hoverRow: {
        "& .hidden-control": {
            display: "none",
        },
        "&:hover .hidden-control": {
            display: "flex",
            flexGrow: 1,
            justifyContent: "flex-end",
            alignItems: "center",
        },
        "& .will-hide": {
            display: "flex",
            flexGrow: 1,
            justifyContent: "flex-end",
            alignItems: "center",
        },
        "&:hover .will-hide": {
            display: "none",
        },
        "& .no-hide": {
            display: "flex",
            flexGrow: 1,
            justifyContent: "flex-end",
            alignItems: "center",
        },
    },
    table: {
        tableLayout: "fixed",
    },
    tableContainer: {
        maxHeight: "70vh",
        overflowX: 'auto',
    },
    timePicker: {
        maxWidth: "10em",
        paddingRight: appTheme.spacing(1),
    },
    offset: appTheme.mixins.toolbar,
    noPadding: {
        padding: 0,
    },
    colorPickerSwatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
    },
    colorPickerColor: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',
    },
    settingsTable: {
        borderCollapse: 'separate',
        borderSpacing: '0 10px'
    },
    settingsTableCell: {
        padding: '5px',
        textAlign: 'center'
    },
    settingsTableCellInherit: {
        color: 'inherit',
        padding: '5px',
        textAlign: 'center'
    },
    subTableRowCell: {
        paddingBottom: 0,
        paddingTop: 0
    },
    addEventFab: {
        marginLeft: '20px'
    },
    // Statistics Styles
    statisticsContainer: {
        paddingTop: '70px',
    },
    statsHeaderRow: {
        backgroundColor: appTheme.palette.grey[200],
        padding: '0 24px',
        fontWeight: 'bold',
        marginBottom: appTheme.spacing(1),
        borderRadius: 4,
        minHeight: 48,
        display: 'flex',
        alignItems: 'center',
    },
    statsSummaryValue: {
        fontSize: appTheme.typography.pxToRem(14),
        lineHeight: 1.2,
    },
    statsPctText: {
        fontSize: appTheme.typography.pxToRem(11),
        color: appTheme.palette.text.secondary,
    },
    statsHeaderText: {
        fontWeight: 'bold',
        fontSize: appTheme.typography.pxToRem(14),
        textAlign: 'center',
    },
    statsTableRow: {
        padding: '8px 0',
        borderBottom: `1px solid ${appTheme.palette.divider}`,
        '&:last-child': {
            borderBottom: 'none',
        },
        '&:nth-of-type(even)': {
            backgroundColor: appTheme.palette.action.hover,
        },
    },
    statsCellText: {
        fontSize: appTheme.typography.pxToRem(14),
        textAlign: 'center',
        lineHeight: 1.2,
    },
    statsTypeText: {
        fontSize: appTheme.typography.pxToRem(14),
        fontWeight: appTheme.typography.fontWeightMedium,
    },
    statsChartContainer: {
        padding: appTheme.spacing(2),
        marginTop: appTheme.spacing(2),
    },
    statsChartArea: {
        display: 'flex',
        marginTop: appTheme.spacing(4),
        minHeight: 300,
        alignItems: 'flex-start',
    },
    statsScaleContainer: {
        width: 45,
        borderRight: `2px solid ${appTheme.palette.divider}`,
        paddingRight: appTheme.spacing(1),
        height: 250, 
        position: 'relative',
    },
    statsScaleTickWrapper: {
        position: 'absolute',
        right: -2,
        width: '100%',
        height: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    statsScaleTick: {
        width: 8,
        height: 2,
        backgroundColor: appTheme.palette.divider,
    },
    statsScaleLabel: {
        fontSize: appTheme.typography.pxToRem(11),
        color: appTheme.palette.text.primary,
        fontWeight: 'bold',
        textAlign: 'right',
        marginRight: appTheme.spacing(1),
    },
    statsBarArea: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: appTheme.spacing(3),
        paddingLeft: appTheme.spacing(2),
        flexGrow: 1,
        overflowX: 'auto',
    },
    statsBarWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
        width: 60,
    },
    statsBarTrack: {
        width: 30,
        height: 250, 
        position: 'relative',
        backgroundColor: 'transparent',
        borderRadius: '4px 4px 0 0',
    },
    statsBarFill: {
        width: '100%',
        backgroundColor: appTheme.palette.primary.main,
        position: 'absolute',
        bottom: 0,
        transition: 'height 0.5s ease-in-out',
    },
    statsBarSegment: {
        width: '100%',
        position: 'absolute',
        transition: 'height 0.5s ease-in-out',
    },
    statsVerticalLabel: {
        marginTop: appTheme.spacing(1),
        width: '100%',
        textAlign: 'center',
        fontSize: appTheme.typography.pxToRem(11),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    statsPieContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 350,
    },
    statsChipContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: appTheme.spacing(1),
        marginBottom: appTheme.spacing(3),
        justifyContent: 'center',
    },
    statsLegendItem: {
        display: 'flex',
        alignItems: 'center',
        margin: appTheme.spacing(0.5, 2),
    },
    statsColorBox: {
        width: 16,
        height: 16,
        marginRight: appTheme.spacing(1),
        borderRadius: 2,
    },
    // CollapsibleSection Styles
    collapsibleRoot: {
        width: '100%',
        marginBottom: appTheme.spacing(2),
    },
    collapsibleSummaryRoot: {
        padding: '0 24px',
        '&.Mui-expanded': {
            minHeight: 48,
        }
    },
    collapsibleSummaryContent: {
        margin: '12px 0',
        '&.Mui-expanded': {
            margin: '12px 0',
        },
        display: 'flex',
        alignItems: 'center',
    },
    collapsibleHeading: {
        fontSize: appTheme.typography.pxToRem(18),
        fontWeight: appTheme.typography.fontWeightBold,
    },
    collapsibleDetails: {
        flexDirection: 'column',
        padding: '0 24px 16px 24px',
    },
    collapsibleExpandIcon: {
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    collapsibleExpanded: {
        transform: 'rotate(180deg)',
    },
    checkboxGreen: {
        color: colors.green[500],
        '&$checked': {
            color: colors.green[500],
        },
    },
    checkboxRed: {
        color: colors.red[500],
        '&$checked': {
            color: colors.red[500],
        },
    },
    checkboxGrey: {
        color: colors.grey[500],
        '&$checked': {
            color: colors.grey[500],
        },
    },
    checked: {},
    stickyColumn: {
        position: 'sticky',
        backgroundColor: appTheme.palette.background.paper,
    },
    stickyDate: {
        left: 0,
        width: '100px',
        minWidth: '100px',
    },
    stickyType: {
        left: '100px',
        width: '140px',
        minWidth: '140px',
    },
    stickyHeaderZ: {
        zIndex: 3,
    },
    stickyBodyZ: {
        zIndex: 1,
    }
};